export default __webpack_public_path__ + "935cb80a05b218d172107fbfd5fe202c.png";